/* import __COLOCATED_TEMPLATE__ from './all-categories-section-link.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();